'use client';

import { c as _c } from "react/compiler-runtime";
import { Check, CircleDashed, Loader2, MessageSquare, X } from 'lucide-react';
import type { CubicRunStatus, CubicStatus } from './pr-v2-sidebar-model';
import { BetterTooltip } from '@/components/ui/tooltip';
const CUBIC_STATUS_ICON_CLASS = 'size-4';
function CubicStatusIcon(t0) {
  const $ = _c(5);
  const {
    status
  } = t0;
  if (status === "running") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Loader2 className={`${CUBIC_STATUS_ICON_CLASS} animate-spin text-zinc-500`} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (status === "failed") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <X className={`${CUBIC_STATUS_ICON_CLASS} text-zinc-500`} />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (status === "issues") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <MessageSquare className={`${CUBIC_STATUS_ICON_CLASS} text-zinc-500`} />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (status === "clean") {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Check className={`${CUBIC_STATUS_ICON_CLASS} text-green-700`} />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CircleDashed className={`${CUBIC_STATUS_ICON_CLASS} text-zinc-500`} />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}

/**
 * cubic's AI review status for the reviewer lists: an icon with the status tooltip, followed by
 * the progress percentage while a review runs. Shared by the PR page sidebar and the /code PR tab.
 */
export function CubicReviewStatus(t0) {
  const $ = _c(16);
  const {
    status,
    isLoading,
    iconSlotClassName,
    tooltipSide
  } = t0;
  const t1 = isLoading ? "Loading review status\u2026" : status.tooltip;
  let t2;
  if ($[0] !== isLoading || $[1] !== status.status) {
    t2 = isLoading ? <CircleDashed className={`${CUBIC_STATUS_ICON_CLASS} text-zinc-500`} /> : <CubicStatusIcon status={status.status} />;
    $[0] = isLoading;
    $[1] = status.status;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== iconSlotClassName || $[4] !== t2) {
    t3 = <span className={iconSlotClassName}>{t2}</span>;
    $[3] = iconSlotClassName;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== tooltipSide) {
    t4 = <BetterTooltip content={t1} side={tooltipSide}>{t3}</BetterTooltip>;
    $[6] = t1;
    $[7] = t3;
    $[8] = tooltipSide;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== status.progressPercentage || $[11] !== status.status) {
    t5 = status.status === "running" && status.progressPercentage != null ? <span className="text-xs tabular-nums text-zinc-500">{`${status.progressPercentage}%`}</span> : null;
    $[10] = status.progressPercentage;
    $[11] = status.status;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}